import { useEffect, useState } from "react";
import img1 from "../../assets/images/impact.svg";
import img2 from "../../assets/images/Strategic-consulting.svg";
import img3 from "../../assets/images/Climate.svg";

const images = [img1, img2, img3];

const HeroSlideshow = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000); // change every 3 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full h-full flex justify-center items-center relative">
      {images.map((img, index) => (
        <img
          key={index}
          src={img}
          alt={`slide-${index}`}
          className={`absolute inset-0 w-full h-full max-w-full h-auto object-contain transition-opacity duration-1000 ease-in-out ${
            index === current ? "opacity-100" : "opacity-0"
          }`}
        />
      ))}
    </div>
  );
};

export default HeroSlideshow;
